import React from "react";
import "./About.css";

const About = () => {
  return (
    <section id="about-us" className="about">
      
      {/* LEFT IMAGE */}
      <div className="about-left">
        <img
          src="https://images.unsplash.com/photo-1593113630400-ea4288922497"
          alt="about"
        />
      </div>

      {/* RIGHT CONTENT */}
      <div className="about-right">
        <span className="about-badge">ABOUT US</span>

        <h2>About Us</h2>

        <p>
          
Education & Environment Society a non-profit, non-Government Organisation structured like a premier Think Tank in the country on issues relating to Education & Environment registered under Societies Registration Act 1860.
 

At Education & Environment Society (EES), we envision a world where education and environmental sustainability intersect seamlessly, creating empowered individuals and thriving ecosystems. Founded on the belief that education is the catalyst for positive change and environmental stewardship is our moral imperative, EES is dedicated to fostering a culture of learning, awareness, and action.   </p>

        <p>
          We work with people and communities to unlock opportunities, share
          knowledge, and create meaningful change together.
        </p>

        {/* STATS */}
       <div className="about-stats">
  <div>
    <h3>1860</h3>
    <p>Act Registered Under</p>
  </div>

  <div>
    <h3>100%</h3>
    <p>Focus on Education & Environment</p>
  </div>

  <div>
    <h3>2+</h3>
    <p>Core Impact Areas</p>
  </div>
</div>
      </div>
    </section>
  );
};

export default About;